import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type EditProps = React.HTMLAttributes<HTMLDivElement> & {};

export const Edit: React.FC<EditProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/edit.svg"} alt="" />
    </div>
  );
};